"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusDot = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../../utils");
const dotColors = {
    success: 'bg-green-500',
    warning: 'bg-amber-500',
    danger: 'bg-red-500',
    neutral: 'bg-gray-400',
    accent: 'bg-accent',
};
const StatusDot = ({ tone, label, className, ...props }) => ((0, jsx_runtime_1.jsxs)("span", { className: (0, utils_1.cn)('inline-flex items-center gap-1.5 text-sm text-gray-700 dark:text-gray-300 whitespace-nowrap', className), ...props, children: [(0, jsx_runtime_1.jsx)("span", { "aria-hidden": "true", className: (0, utils_1.cn)('inline-block h-1.5 w-1.5 shrink-0 rounded-full', dotColors[tone]) }), label] }));
exports.StatusDot = StatusDot;
exports.StatusDot.displayName = 'StatusDot';
